// Category-list layout preference: the masonry GALLERY of cover tiles (the
// default) or a LIST of glass rows (the "Continue watching" shape). One
// device-wide setting shared by every category list, remembered in
// localStorage; storage failures fall back to the gallery.

const KEY = "mt_list_view";
export const VIEW_MODES = ["gallery", "list"];
const DEFAULT = "gallery";

function valid(mode) {
	return VIEW_MODES.includes(mode) ? mode : DEFAULT;
}

export function getListView() {
	try {
		return valid(localStorage.getItem(KEY));
	} catch {
		return DEFAULT;
	}
}

// Persists and returns the mode actually stored (junk → gallery).
export function setListView(mode) {
	const v = valid(mode);
	try {
		localStorage.setItem(KEY, v);
	} catch {
		// storage unavailable — the choice lives for this screen only
	}
	return v;
}
